module.exports = __webpack_public_path__ + "static/media/thoracic-surgery-top.8172157e.svg";